import {
  CAMPAIGNS_ASSETS_HOMEPAGE_ONBOARDING,
  CAMPAIGN_ON_BOARDING,
  CONTENT_EXPLORER_ONBOARDING,
  CREATE_CAMPAIGN_TRY_IT_NOW_ONBOARDING,
  OPEN_CAMPAIGN_FIRST_TIME_ONBOARDING,
} from "constants/types";

const onBoardingInitialState = {
  campaignAssetsOnBoardingShow: false,
  createCampaignTryItNow: false,
  createCampaignStepNo: 0,
  openCampaignFirstTime: false,
  checkBlogItemTryItNow: false,
  campaignSmartSourceUpdateKeyword: false,
  isCampaignContactListSelected: false,
  showCampaignAudienceListSelection: false,
  // campaigns
  blogId: "0",
};

export const onBoardingReducer = (state: any = onBoardingInitialState, action: any) => {
  const newState = { ...state };
  switch (action.type) {
    case CAMPAIGNS_ASSETS_HOMEPAGE_ONBOARDING.SHOW:
      newState.campaignAssetsOnBoardingShow = true;
      return newState;

    case CREATE_CAMPAIGN_TRY_IT_NOW_ONBOARDING.SHOW:
      newState.createCampaignTryItNow = true;
      return newState;

    case CREATE_CAMPAIGN_TRY_IT_NOW_ONBOARDING.HIDE:
      newState.createCampaignTryItNow = false;
      return newState;

    case CREATE_CAMPAIGN_TRY_IT_NOW_ONBOARDING.SET_STEP:
      newState.createCampaignStepNo = action.payload;
      return newState;

    case OPEN_CAMPAIGN_FIRST_TIME_ONBOARDING.SHOW:
      newState.openCampaignFirstTime = true;
      return newState;

    case OPEN_CAMPAIGN_FIRST_TIME_ONBOARDING.HIDE:
      newState.openCampaignFirstTime = false;
      return newState;

    case CONTENT_EXPLORER_ONBOARDING.SHOW_CHECKBOX_TRY_NOW:
      newState.checkBlogItemTryItNow = true;
      return newState;

    case CONTENT_EXPLORER_ONBOARDING.HIDE_CHECKBOX_TRY_NOW:
      newState.checkBlogItemTryItNow = false;
      return newState;

    case CONTENT_EXPLORER_ONBOARDING.SET_ID:
      newState.blogId = action.payload;
      return newState;

    case CAMPAIGN_ON_BOARDING.SMART_SOURCE_SET_UPDATE_KEYWORD:
      newState.campaignSmartSourceUpdateKeyword = action.payload;
      return newState;

    case CAMPAIGN_ON_BOARDING.AUDIENCE_SET_SELECTED_LIST:
      newState.isCampaignContactListSelected = action.payload;
      return newState;

    case CAMPAIGN_ON_BOARDING.AUDIENCE_SET_SHOW_LIST:
      newState.showCampaignAudienceListSelection = action.payload;
      return newState;

    default:
      return newState;
  }
};
